import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEntitiesColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 8,
			width: 10,
			height: 10,
			rx: 3,
			fill: "url(#paint0_linear_entities)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22,
			y: 8,
			width: 10,
			height: 10,
			rx: 3,
			fill: "url(#paint0_linear_entities)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 22,
			width: 10,
			height: 10,
			rx: 3,
			fill: "url(#paint0_linear_entities)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22,
			y: 22,
			width: 10,
			height: 10,
			rx: 3,
			fill: "url(#paint0_linear_entities)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_entities",
			x1: 32,
			y1: 32,
			x2: 8,
			y2: 8,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#53BCDE" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#767CFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#AC8EFF"
				})
			]
		}) })
	]
});
export default SvgEntitiesColored;
